const grant = {
  getManageGrants: async function(
    offset,
    limit,
    includeExpired,
    orderBy,
    searchKeyword,
    statuses,
    assignedUser,
    types,
    onlyExpired = false
  ) {
    var view = this;
    var keywordQuery =
      searchKeyword != "" ? ', keyword: "' + searchKeyword + '"' : "";
    var statusQuery =
      statuses.length > 0 ? ", statuses: [" + statuses + "]" : "";
    var assignedUserQuery = assignedUser
      ? ", assignedTo: " + parseInt(view.$store.getters.user.User_Id)
      : "";
    var awardTypeQuery =
      types.length > 0 ? ", typeFilter: [" + types + "]" : "";

    var res = await view.$store.getters.fetcher({
      query:
        `{
          grants(offset: ` +
        offset +
        `, limit:` +
        limit +
        `, orderBy: ` +
        '"' +
        orderBy +
        '"' +
        `, includeExpired: ` +
        includeExpired +
        keywordQuery +
        statusQuery +
        assignedUserQuery +
        awardTypeQuery +
        `, onlyExpired: ` +
        onlyExpired +
        `){
            Grant_Id
            Title
            Description
            Organization
            Award_Amount
            Application_Deadline
            URL
            Teaching_Grade
            Teaching_Subject
            Date_Added
            State
            Award_Level
            Eligibility
            Status
            Requires_501C3
            Award_Type
            Added_By {
              User_Id
              First_Name
              Last_Name
            }
            Last_Edited_By {
              User_Id
              First_Name
              Last_Name
            }
            Assigned_To {
              User_Id
              First_Name
              Last_Name
            }
            Notes {
              Grant_Note_Id
              Note
              Written_By{
                First_Name
                Last_Name
              }
              Grant_Note_Type
              createdAt
            }
          }
        }`
    });
    return res.data.grants;
  },

  getManageGrantsCount: async function(
    includeExpired,
    searchKeyword,
    statuses,
    assignedUser,
    types
  ) {
    var view = this;
    var keywordQuery =
      searchKeyword != "" ? ', keyword: "' + searchKeyword + '"' : "";
    var statusQuery =
      statuses.length > 0 ? ", statuses: [" + statuses + "]" : "";
    var assignedUserQuery = assignedUser
      ? ", assignedTo: " + parseInt(view.$store.getters.user.User_Id)
      : "";
    var awardTypeQuery =
      types.length > 0 ? ", typeFilter: [" + types + "]" : "";
    var res = await this.$store.getters.fetcher({
      query:
        `{
        grantsCount(` +
        `includeExpired: ` +
        includeExpired +
        keywordQuery +
        statusQuery +
        assignedUserQuery +
        awardTypeQuery +
        `)}`
    });
    return res.data.grantsCount;
  },

  getGrants: async function(
    grades,
    levels,
    subjects,
    keyword,
    offset,
    limit,
    includeExpired,
    orderBy,
    showNotInterested,
    notInterested,
    state,
    eligibility,
    status,
    awardType
  ) {
    var view = this;

    var keywordQuery = keyword != "" ? ', keyword: "' + keyword + '"' : "";
    var notInterestedQuery = "";
    if (!showNotInterested && notInterested > 0) {
      notInterestedQuery = ", notInterested: [" + notInterested + "]";
    }
    var statusQuery = status ? ", status: " + status : "";
    var accountQuery =
      parseInt(view.$store.getters.user.Account_Id) == 1
        ? ""
        : ", accountId: " + parseInt(view.$store.getters.user.Account_Id);
    var awardTypeQuery = awardType ? ", awardType: " + awardType : "";

    var res = await view.$store.getters.fetcher({
      query:
        `{
        grants(grades: ` +
        grades +
        `, levels: ` +
        levels +
        `, subjects: ` +
        subjects +
        `, includeExpired: ` +
        includeExpired +
        `, offset: ` +
        offset +
        `, limit: ` +
        limit +
        `, orderBy: ` +
        '"' +
        orderBy +
        '"' +
        keywordQuery +
        notInterestedQuery +
        `, state: ` +
        state +
        `, eligibility: ` +
        eligibility +
        statusQuery +
        accountQuery +
        awardTypeQuery +
        `) {
          Grant_Id
          Title
          Description
          Organization
          Award_Amount
          Application_Deadline
          URL
          Teaching_Grade
          Teaching_Subject
          Award_Level
          Date_Added
          State
          Eligibility
          Requires_501C3
          Award_Type
        }
      }`
    });
    return res.data.grants;
  },

  getGrantsCount: async function(
    grades,
    levels,
    subjects,
    keyword,
    includeExpired,
    showNotInterested,
    notInterested,
    state,
    eligibility,
    status,
    awardType
  ) {
    var view = this;

    var keywordQuery = keyword != "" ? ', keyword: "' + keyword + '"' : "";
    var notInterestedQuery = "";
    if (!showNotInterested && notInterested > 0) {
      notInterestedQuery = ", notInterested: [" + notInterested + "]";
    }
    var statusQuery = status ? ", status: " + status : "";
    var accountQuery =
      parseInt(view.$store.getters.user.Account_Id) == 1
        ? ""
        : ", accountId: " + parseInt(view.$store.getters.user.Account_Id);
    var awardTypeQuery = awardType ? ", awardType: " + awardType : "";

    var res = await view.$store.getters.fetcher({
      query:
        `{
        grantsCount(grades: ` +
        grades +
        `, levels: ` +
        levels +
        `, subjects: ` +
        subjects +
        `, includeExpired: ` +
        includeExpired +
        keywordQuery +
        notInterestedQuery +
        `, state: ` +
        state +
        `, eligibility: ` +
        eligibility +
        statusQuery +
        accountQuery +
        awardTypeQuery +
        `) 
      }`
    });
    return res.data.grantsCount;
  },

  createGrantNote: async function(grantId, noteType, note) {
    var view = this;
    const query = `
      mutation($grantId: Int!, $note: String!, $grantNoteType: Int!, $writtenBy: Int!) {
        CreateGrantNote(grantId: $grantId, note: $note, grantNoteType: $grantNoteType, writtenBy: $writtenBy) {
          Grant_Note_Id
        }
      }`;
    const variables = {
      grantId: parseInt(grantId),
      note: note,
      grantNoteType: noteType,
      writtenBy: parseInt(view.$store.getters.user.User_Id)
    };
    return await view.$store.getters.fetcher({ query, variables });
  },

  createGrant: async function(grantToAdd) {
    var addedGrant = {};
    const query = `
      mutation($title: String!, $description: String!, $organization: String!, $awardAmount: String!, $applicationDeadline: Date!, $url: String!, $teachingGrade: Int!, $teachingSubject: Int!, $awardLevel: Int!, $state: BigInt!, $eligibility: Int!, $addedBy: Int!, $dateAdded: Date!, $requires501C3: Boolean!, $awardType: Int!  ) {
        CreateGrant(title: $title, description: $description, organization: $organization, awardAmount: $awardAmount, applicationDeadline: $applicationDeadline, url: $url, teachingGrade: $teachingGrade, teachingSubject: $teachingSubject, awardLevel: $awardLevel, state: $state, eligibility: $eligibility, addedBy: $addedBy dateAdded: $dateAdded, requires501C3: $requires501C3, awardType: $awardType ) {
          Grant_Id
          Added_By {
            User_Id
            First_Name
            Last_Name
          }
          Last_Edited_By {
            User_Id
            First_Name
            Last_Name
          }
        }
      }`;
    const variables = {
      title: grantToAdd.Title.trim(),
      description: grantToAdd.Description.trim(),
      organization: grantToAdd.Organization.trim(),
      awardAmount: grantToAdd.Award_Amount,
      applicationDeadline:
        grantToAdd.Application_Deadline != "0000-00-00"
          ? new Date(grantToAdd.Application_Deadline).setHours(0, 0, 0, 0)
          : grantToAdd.Application_Deadline,
      url: grantToAdd.URL.trim(),
      teachingGrade: grantToAdd.Teaching_Grade,
      teachingSubject: grantToAdd.Teaching_Subject,
      awardLevel: grantToAdd.Award_Level,
      state: grantToAdd.State,
      eligibility: grantToAdd.Eligibility,
      dateAdded: new Date(),
      addedBy: parseInt(this.$store.getters.user.User_Id),
      requires501C3: grantToAdd.Requires_501C3,
      awardType: parseInt(grantToAdd.Award_Type)
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      addedGrant = grantToAdd;
      addedGrant.Grant_Id = r.data.CreateGrant.Grant_Id;
      addedGrant.Last_Edited_By = r.data.CreateGrant.Last_Edited_By;
      return addedGrant;
    });
  },

  updateGrant: async function(grantToUpdate) {
    var view = this;
    const query = `
      mutation($grantId: Int!, $title: String!, $description: String!, $organization: String!, $awardAmount: String!, $applicationDeadline: Date!, $url: String!, $teachingGrade: Int!, $teachingSubject: Int!, $awardLevel: Int!, $state: BigInt!, $eligibility: Int!, $lastEditedBy: Int!, $dateAdded: Date!, $requires501C3: Boolean!, $status: Int, $awardType: Int! ) {
        UpdateGrant(grantId: $grantId, title: $title, description: $description, organization: $organization, awardAmount: $awardAmount, applicationDeadline: $applicationDeadline, url: $url, teachingGrade: $teachingGrade, teachingSubject: $teachingSubject, awardLevel: $awardLevel, state: $state, eligibility: $eligibility, lastEditedBy: $lastEditedBy, dateAdded: $dateAdded, requires501C3: $requires501C3, status: $status, awardType: $awardType ) {
          Grant_Id
        }
      }`;
    const variables = {
      grantId: parseInt(grantToUpdate.Grant_Id),
      title: grantToUpdate.Title.trim(),
      description: grantToUpdate.Description.trim(),
      organization: grantToUpdate.Organization.trim(),
      awardAmount: grantToUpdate.Award_Amount,
      applicationDeadline:
        grantToUpdate.Application_Deadline != "0000-00-00"
          ? new Date(grantToUpdate.Application_Deadline).setHours(0, 0, 0, 0)
          : grantToUpdate.Application_Deadline,
      url: grantToUpdate.URL.trim(),
      teachingGrade: grantToUpdate.Teaching_Grade,
      teachingSubject: grantToUpdate.Teaching_Subject,
      awardLevel: grantToUpdate.Award_Level,
      state: grantToUpdate.State,
      eligibility: grantToUpdate.Eligibility,
      lastEditedBy: parseInt(view.$store.getters.user.User_Id),
      dateAdded: new Date(),
      requires501C3: grantToUpdate.Requires_501C3,
      status: grantToUpdate.Status,
      awardType: parseInt(grantToUpdate.Award_Type)
    };
    return await this.$store.getters.fetcher({ query, variables }).then(() => {
      return grantToUpdate;
    });
  }
};

export { grant };
